export default __webpack_public_path__ + "static/media/Weerwood Seed.c3fd1c08.PNG";